export default __webpack_public_path__ + "static/media/Volume Down.fb0538ad.svg";